import React, { useCallback, useState } from 'react';
import { AppButton, Box, PlusThinIcon, RoundDoneIcon, Text } from '@common-fe/common-fe';

import { ROUTES } from '@/common';
import { Modal } from '@/components';
import { useHistory } from '@/modules/core';

import { ReportTypeKeys } from '../report.types';

import { ScheduledReportsTabs } from './ScheduledReports/ScheduledReports';
import { ScheduledReportPayload } from './ScheduledReport.types';
import ScheduledReportSetup from './ScheduledReportSetup';

interface Props extends Partial<ScheduledReportPayload> {
  type?: ReportTypeKeys;
  isStandAloneMode?: boolean;
}

const AddScheduledReportButton: React.FC<Props> = (props) => {
  const [isPreviewShowed, setPreviewShowed] = useState(false);
  const [visible, setVisible] = useState(false);

  const handleCloseModal = useCallback(() => {
    setVisible(false);
  }, []);

  const history = useHistory();
  const [isSuccess, setSuccess] = useState(false);
  const handleRedirectToList = useCallback(() => {
    history.push(`${ROUTES.SCHEDULED_REPORTS}`, {
      tab: ScheduledReportsTabs.Schedule,
    });
    setVisible(false);
    setSuccess(false);
  }, [history]);
  const handleShowModal = useCallback(() => {
    setVisible(true);
  }, []);

  const handleCloseSuccess = useCallback(() => {
    setSuccess(false);
  }, []);

  return (
    <>
      <Modal visible={isSuccess} wrapperStyle={{ zIndex: 10000 }} onSetVisible={() => setSuccess(false)}>
        <Box align="center" direction="column" margin={{ vertical: 'spacing24' }}>
          <RoundDoneIcon />
          <Text size="2xl" weight={700} margin={{ top: 'spacing12' }}>
            Schedule has been successfully created!
          </Text>
          <Box direction="row" align="center" justify="center" margin={{ top: 'spacing24' }}>
            <AppButton width="200px" buttonType="secondary" onClick={handleRedirectToList}>
              Check All Schedules
            </AppButton>
            <Box width="spacing12" />
            <AppButton onClick={handleCloseSuccess} width="200px">
              Got It
            </AppButton>
          </Box>
        </Box>
      </Modal>
      <Modal
        testId="add-scheduled-report"
        maxWidth={isPreviewShowed ? '880px' : undefined}
        visible={visible}
        onSetVisible={handleCloseModal}
      >
        <ScheduledReportSetup
          defaultEmployerId={props.employerId}
          onSetPreviewShowed={setPreviewShowed}
          {...props}
          employerId={props.employerId}
          onClose={handleCloseModal}
          onSuccess={() => setSuccess(true)}
        />
      </Modal>
      <AppButton
        disabled={!props.isStandAloneMode && !props.employerId && !props.isMultipleEmployer}
        buttonType="secondary"
        testId="add-scheduled-report"
        color="grey"
        rightIcon={<PlusThinIcon />}
        onClick={handleShowModal}
      >
        Add Schedule
      </AppButton>
    </>
  );
};
export default AddScheduledReportButton;
